import type { Reward } from '@/interfaces/user.interface'
import { HttpMethod, Performer } from '../core'
import type { Task } from './types'

export class ListTasks extends Performer<
  void,
  {
    dailyRewards: Reward[]
    tasks: Task[]
  }
> {
  protected method = HttpMethod.GET
  protected url = '/tasks'
}
